import styled from 'styled-components'

import Tag from '~/shared/components/tags/Tag'

type Props = {
  data: any
}

function TicketInfo({ data }: Props) {
  const { ticket_rule, ticket_type, buy_method } = data

  return (
    <Wrapper>
      <TagBox>
        <Tag $size={'md'} $variant={'gray'}>
          티켓 종류
        </Tag>
        <Desc>{ticket_type}</Desc>
      </TagBox>
      <TagBox>
        <Tag $size={'md'} $variant={'gray'}>
          티켓 구매 방법
        </Tag>
        <Desc>{buy_method}</Desc>
      </TagBox>
      <TagBox>
        <Tag $size={'md'} $variant={'gray'}>
          티켓 관련 규칙
        </Tag>
        <Desc>{ticket_rule}</Desc>
      </TagBox>
    </Wrapper>
  )
}

export default TicketInfo

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const TagBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Desc = styled.p`
  padding-left: 20px;

  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  white-space: pre-line;
`
